import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import AdminShell from "./AdminShell";
import DataTable from "./components/DataTable";
import { usersAll } from "./api";

const COLUMNS = [
  { key: "user_id", label: "ID" },
  { key: "username", label: "Username" },
  { key: "user_type", label: "Type" },
  { key: "email", label: "Email" },
  { key: "u_phoneno", label: "Phone" },
];

export default function AdminPanel() {
  const history = useHistory();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await usersAll();
        setRows(Array.isArray(res.data) ? res.data.filter((r) => r.username) : []);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const logout = () => {
    localStorage.removeItem("adminlogged");
    history.push("/adminlogin");
  };

  return (
    <AdminShell title="Users" onLogout={logout}>
      <DataTable caption="All registered users" columns={COLUMNS} rows={rows} emptyLabel="No users found." />
    </AdminShell>
  );
}
